function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M467 60c16 0 30 14 30 30v392c0 17-14 30-30 30H45c-16 0-30-13-30-30V90c0-16 14-30 30-30h60V30c0-17 14-30 31-30 16 0 30 13 30 30v30h180V30c0-17 14-30 30-30 17 0 31 13 31 30v30zM75 452h362V181H75zm256-60c-8 0-15-7-15-16v-30c0-8 7-15 15-15h30c9 0 15 7 15 15v30c0 9-6 16-15 16zm0-91c-8 0-15-7-15-15v-30c0-8 7-15 15-15h30c9 0 15 7 15 15v30c0 8-6 15-15 15zm-90 91c-8 0-15-7-15-16v-30c0-8 7-15 15-15h30c8 0 15 7 15 15v30c0 9-7 16-15 16zm0-91c-8 0-15-7-15-15v-30c0-8 7-15 15-15h30c8 0 15 7 15 15v30c0 8-7 15-15 15zm-90 91c-9 0-15-7-15-16v-30c0-8 6-15 15-15h30c8 0 15 7 15 15v30c0 9-7 16-15 16zm0-91c-9 0-15-7-15-15v-30c0-8 6-15 15-15h30c8 0 15 7 15 15v30c0 8-7 15-15 15z"
})));